export const bronsonTheme =
  process.env.REACT_APP_WEBSITE_BRONSON_THEME || 'bluelabel'

export const getStylesCharly = brandName => {
  const brand = brandName.toLowerCase()

  switch (brand) {
    case 'seat':
      return import('@vwfs-uix/core/dist/themes/seat/styles/style.css')
    case 'audi':
      return import('@vwfs-uix/core/dist/themes/audi/styles/style.css')
    case 'skoda':
      return import('@vwfs-uix/core/dist/themes/skoda/styles/style.css')
    case 'vw6':
    case 'vw':
      return import('@vwfs-uix/core/dist/themes/vw6/styles/style.css')
    case 'cupra':
      return import('@vwfs-uix/core/dist/themes/cupra/styles/style.css')
    default:
      return import('@vwfs-uix/core/dist/themes/bluelabel/styles/style.css')
  }
}
